import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { authGuard } from './security/guards/auth.guard';
import { GroupsComponent } from './components/groups/groups.component';
import { DataProviderSystemsComponent } from './components/data-provider-systems/data-provider-systems.component';
import { FeaturesComponent } from "./components/features/features.component";
import { MappingComponent } from "./components/mapping/mapping.component";
import { CustomersComponent } from "./components/customers/customers.component";
import { CustomerComponent } from './components/customers/customer/customer.component';
import { StatisticsComponent } from "./components/statistics/statistics.component";
import { ConfigurationComponent } from './components/configuration/configuration.component';
import { DataSourcesComponent } from "./components/data-sources/data-sources.component";
import { UsersComponent } from "./components/users/users.component";
import { AlertStatusComponent } from "./components/alert-status/alert-status.component";
import { QuickfiltersComponent } from "./components/quickfilters/quickfilters.component";
import { AssetsManagementComponent } from './components/assets-management/assets-management.component';
import { StandardTileComponent } from './components/standard-tile/standard-tile.component';
import { TrackingLaneComponent } from './components/tracking-lane/tracking-lane.component';
import { TrackingLanesComponent } from './components/tracking-lanes/tracking-lanes.component';
import { DecisionMakerComponent } from './components/dashboard/decision-maker/decision-maker.component';
import { ApiCallsComponent } from './components/api-calls/api-calls.component';
import { PushNotificationsComponent } from './components/push-notifications/push-notifications.component';


export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '', component: DashboardComponent,
        children: [
            { path: '', redirectTo: 'statistics', pathMatch: 'full' },
            { path: 'statistics', component: StatisticsComponent, canActivate: [authGuard] },
            { path: 'groups', component: GroupsComponent, canActivate: [authGuard] },
            { path: 'dataproviders', component: DataProviderSystemsComponent, canActivate: [authGuard] },
            { path: 'features', component: FeaturesComponent, canActivate: [authGuard] },
            { path: 'data-sources', component: DataSourcesComponent, canActivate: [authGuard] },
            { path: 'mapping', component: MappingComponent, canActivate: [authGuard] },
            { path: 'tenants', component: CustomersComponent, canActivate: [authGuard] },
            { path: 'users', component: UsersComponent, canActivate: [authGuard] },
            { path: 'tenants/:id', component: CustomerComponent, canActivate: [authGuard] },
            { path: 'tenants/create', component: CustomerComponent, canActivate: [authGuard] },
            { path: 'config', component: ConfigurationComponent, canActivate: [authGuard] },
            { path: 'alert-status', component: AlertStatusComponent, canActivate: [authGuard] },
            { path: 'quickfilter', component: QuickfiltersComponent, canActivate: [authGuard] },
            { path: 'standardfilter', component: QuickfiltersComponent, canActivate: [authGuard] },
            { path: 'assets', component: AssetsManagementComponent, canActivate: [authGuard] },
            { path: 'standard-tile', component: StandardTileComponent, canActivate: [authGuard] },
            { path: 'tracking-lanes', component: TrackingLanesComponent, canActivate: [authGuard] },
            { path: 'tracking-lane', component: TrackingLaneComponent, canActivate: [authGuard] },
            { path: 'tracking-lane/:id', component: TrackingLaneComponent, canActivate: [authGuard] },
            { path: 'decision-maker', component: DecisionMakerComponent, canActivate: [authGuard] },
            { path: 'api-calls', component: ApiCallsComponent, canActivate: [authGuard] },
            { path: 'push-notifications', component: PushNotificationsComponent, canActivate: [authGuard] },
        ],
        canActivate: [authGuard]
    },
    { path: '**', redirectTo: '' }
];
